"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _inputModule = _interopRequireDefault(require("./input.module.scss"));
var _noop = require("../../utils/noop");
var defaultProps = {
  className: undefined,
  type: 'text',
  value: '',
  onChange: _noop.noop,
  onFocus: _noop.noop,
  onBlur: _noop.noop,
  onKeyDown: _noop.noop,
  placeholder: undefined,
  maxLength: null,
  autoFocus: false,
  autoComplete: 'on',
  readOnly: false,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  disabled: false,
  required: false,
  defaultValue: undefined,
  extensionProps: {},
  rest: {},
  large: false,
  error: false
};
var Input = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;
  var id = props.id,
    type = props.type,
    className = props.className,
    name = props.name,
    value = props.value,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    placeholder = props.placeholder,
    maxLength = props.maxLength,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    readOnly = props.readOnly,
    ariaInvalid = props.ariaInvalid,
    ariaDescribedBy = props.ariaDescribedBy,
    disabled = props.disabled,
    required = props.required,
    defaultValue = props.defaultValue,
    extensionProps = props.extensionProps,
    pattern = props.pattern,
    large = props.large,
    error = props.error,
    small = props.small;
  var valueProp = defaultValue !== undefined ? {
    defaultValue: defaultValue
  } : {
    value: value
  };
  return /*#__PURE__*/_react.default.createElement("input", Object.assign({
    id: id,
    "data-testid": id,
    type: type,
    className: (0, _classnames.default)(_inputModule.default['input'], className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _inputModule.default['input--large'], large), (0, _defineProperty2.default)(_classNames, _inputModule.default['input--small'], small), (0, _defineProperty2.default)(_classNames, _inputModule.default['input--error'], error), _classNames)),
    name: name
  }, valueProp, {
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onBlur: onBlur,
    placeholder: placeholder,
    maxLength: maxLength,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    readOnly: readOnly,
    "aria-invalid": ariaInvalid,
    "aria-describedby": ariaDescribedBy,
    disabled: disabled,
    required: required,
    pattern: pattern ? String(pattern) : undefined
  }, extensionProps, {
    ref: ref
  }));
});
exports.Input = Input;
Input.defaultProps = defaultProps;
Input.displayName = 'Input';